<template>
  <div class="page">
    <PageHeader :links="headLinks" />
    <div class="pageMain">
      <el-row style="padding-bottom: 20px">
        <el-col :span="24">
          <div style="width: 165px; float: left">
            <el-select placeholder="请选择科目/栏目" v-model="subjectId">
              <el-option v-for="item in subjects" :key="item.subjectId" :label="item.name" :value="item.subjectId"> </el-option>
            </el-select>
          </div>
          <div style="width: 300px; float: left">
            <el-input placeholder="作者/稿件标题" v-model="words"></el-input>
          </div>
          <el-button type="primary" @click="search()">查询</el-button>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="sn" label="稿件编号" align="center" width="90"></el-table-column>
            <el-table-column prop="subjectName" label="栏目/科目" width="120"></el-table-column>
            <el-table-column prop="title" label="稿件标题"></el-table-column>
            <el-table-column prop="authorName" label="作者"></el-table-column>
            <el-table-column prop="createTime" align="center" label="投稿时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="step" label="状态" width="130">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.step == 61 || scope.row.step == 40 || scope.row.step == 51" type="warning">{{ getStatusText(scope.row.step) }}</el-tag>
                <el-tag v-else>{{ getStatusText(scope.row.step) }}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pagesize" :current-page="currentPage" @current-change="pageChange"> </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import articleApi from "@/api/article"
import subjectApi from "@/api/subject"

export default {
  components: { PageHeader },
  data() {
    return {
      headLinks: [
        { path: "", title: "基础数据" },
        { path: "", title: "稿件状态查询" },
      ],
      tableData: [],

      subjects: [],
      subjectId: -1,
      status: -1,
      words: "",

      total: 0,
      pagesize: 10,
      currentPage: 1,
    }
  },
  mounted() {
    this.loadSubject()
  },

  methods: {
    loadSubject() {
      subjectApi.getAll().then((res) => {
        let rows = res.data
        rows.unshift({ subjectId: -1, name: "--所有栏目/科目--" })
        this.subjects = rows

        console.log(this.subjects)
        this.loadData()
      })
    },

    getStatusText(step) {
      for (let i = 0; i < this.$config.steps.length; i++) {
        if (step == this.$config.steps[i].step) {
          return this.$config.steps[i].title
        }
      }
      return ""
    },

    loadData() {
      articleApi.getAdminListForPage(this.subjectId, this.status, this.words, "createTime", "DESC", this.currentPage, this.pagesize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    pageChange(curPage) {
      this.currentPage = curPage
      this.loadData()
    },

    search() {
      this.loadData()
    },
  },
}
</script>

<style scoped>
.cardHeader {
  font-size: 16px;
  font-weight: bold;
}
</style>
